import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PaymentPageView from '../presentation/PaymentPageView';
import {
  checkoutDetailsDefaultValue,
  updateCheckoutDetailsWithPaymentsContentReducer,
} from 'common/utilities/CheckoutUtils';
import { getTenders } from 'common/utilities/content';
import { isCurrentPageRedirectFromRNA } from 'common/utilities/utils';

const PaymentPage = props => {
  const dispatch = useDispatch();
  const [paymentDetails, setPaymentDetails] = useState(checkoutDetailsDefaultValue);

  const updatePaymentDetails = useCallback(param => {
    setPaymentDetails && setPaymentDetails(prevState => ({ ...prevState, ...param }));
  }, []);

  const { paymentsContentReducer } = useSelector(data => data);

  useEffect(() => {
    updateCheckoutDetailsWithPaymentsContentReducer(paymentsContentReducer, updatePaymentDetails);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentsContentReducer?.tendersContent]);

  useEffect(() => {
    const urlparmas = new URLSearchParams(window.location.search);
    const urltoken = urlparmas.get('token');
    const gpData = urlparmas.get('gpData');
    const data = JSON.parse(decodeURIComponent(gpData));
    const updatedData = { ...data, RNAtoken: urltoken };
    updatePaymentDetails({
      dispatch,
      isRenderFromRNA: isCurrentPageRedirectFromRNA?.(window?.location),
      paymentEnabled: isCurrentPageRedirectFromRNA?.(window?.location),
      ...updatedData,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    paymentDetails?.tenantId && dispatch(getTenders());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[paymentDetails?.tenantId]);

  return <PaymentPageView {...props} paymentDetails={paymentDetails} updatePaymentDetails={updatePaymentDetails} />;
};

export default PaymentPage;
